import { render, staticRenderFns } from "./boards_dropdown.vue?vue&type=template&id=5858945c&scoped=true&"
import script from "./boards_dropdown.vue?vue&type=script&lang=js&"
export * from "./boards_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./boards_dropdown.vue?vue&type=style&index=0&id=5858945c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858945c",
  null
  
)

export default component.exports